import { Tool } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export type PaginatedToolsParams = Readonly<{
  range: readonly [number, number];
  shuffleSeed: number;
}>;

export type PaginatedToolsResult = Readonly<{
  data: readonly Tool[];
  total: number;
}>;

export const toolsApi = createApi({
  reducerPath: 'toolsApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getTools: build.query<Tool[], undefined>({
      query: () => 'tools',
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getToolsPaginated: build.query<PaginatedToolsResult, PaginatedToolsParams>({
      queryFn: async ({ range, shuffleSeed }, _queryApi, _extraOptions, baseQuery) => {
        const params = new URLSearchParams();

        params.append('range', JSON.stringify(range));
        params.append('shuffle', String(shuffleSeed));

        const result = await baseQuery(`tools?${params.toString()}`);

        if (result.error) {
          return { error: result.error };
        }

        const total = parseInt(
          (result.meta as { response?: Response })?.response?.headers.get('X-Total-Count') ?? '0',
          10,
        );

        return { data: { data: result.data as Tool[], total } };
      },
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getToolByToolId: build.query<Tool, string>({
      query: (toolId) => `tools/tool-id/${toolId}`,
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetToolsQuery,
  useGetToolsPaginatedQuery,
  useGetToolByToolIdQuery,

  usePrefetch: usePrefetchTools,

  util: { resetApiState },
} = toolsApi;
